import request from "@/util/request2";

export function findDataKindAll() {
  return request({
    url: "/api/restful/findDataKindAll",
    method: "get"
  });
}

//查询该市场相应品种蔬菜的历史价格走势
export function findDataSaleKindRecentPrice(data) {
  return request({
    url: "/api/restful/findDataSaleKindRecentPrice",
    method: "get",
    params: data
  });
}

//查询该市场相应品种蔬菜的历史价格走势 new
export function getDataPriceTjByDataMarketNameAndYear(data) {
  return request({
    url: "/api/restful/getDataPriceTjByDataMarketNameAndYear",
    method: "get",
    params: data
  });
}

//根据品种查询市场
export function findDataMarketForKindByDate(data) {
  return request({
    url: "/api/restful/findDataMarketForKindByDate",
    method: "get",
    params: data
  });
}

//蔬菜销售全国
export function findDataSaleBydataKindIdAndYear(data) {
  return request({
    url: "/api/restful/findDataSaleBydataKindIdAndYear",
    method: "get",
    params: data
  });
}

//流向销售（全省）
export function findDataSaleBydataKindIdAndYearAndProvinceCode(data) {
  return request({
    url: "/api/restful/findDataSaleBydataKindIdAndYearAndProvinceCode",
    method: "get",
    params: data
  });
}

//获取月份
export function findDataSaleBydataKindIdGetYear() {
  return request({
    url: "/api/restful/findDataSaleBydataKindIdGetYear",
    method: "get"
  });
}

//蔬菜销售地图
export function findDataSaleBydataKindIdAndYearAndProvinceCodeForMap(data) {
  return request({
    url: "/api/restful/findDataSaleBydataKindIdAndYearAndProvinceCodeForMap",
    method: "get",
    params: data
  });
}
//蔬菜销售地图
export function findDataPriceBydataKindIdAndYearForMap(data) {
  return request({
    url: "/api/restful/findDataPriceBydataKindIdAndYearForMap",
    method: "get",
    params: data
  });
}

//蔬菜销售历史
export function findDataSaleByXSID(data) {
  return request({
    url: "/api/restful/findDataSaleByXSID",
    method: "get",
    params: data
  });
}

//价格行情省排行
export function findDataPriceBydataKindIdAndYear(data) {
  return request({
    url: "/api/restful/findDataPriceBydataKindIdAndYear",
    method: "get",
    params: data
  });
}

//价格行情市排行
export function findDataPriceBydataKindIdAndYearAndProvinceCode(data) {
  return request({
    url: "/api/restful/findDataPriceBydataKindIdAndYearAndProvinceCode",
    method: "get",
    params: data
  });
}
//流向数据（省内）

//蔬菜产量地图数据
export function findDataBrandScByCPIDANDSJ(data) {
  return request({
    url: "/api/restful/findDataBrandScByCPIDANDSJ",
    method: "get",
    params: data
  });
}
//蔬菜产量统计图数据
export function findDataBrandScByCPIDANDSJTJQY(data) {
  return request({
    url: "/api/restful/findDataBrandScByCPIDANDSJTJQY",
    method: "get",
    params: data
  });
}
//蔬菜加工地图数据
export function findDataBrandJgByCPIDANDSJ(data) {
  return request({
    url: "/api/restful/findDataBrandJgByCPIDANDSJ",
    method: "get",
    params: data
  });
}
//蔬菜加工统计图数据
export function findDataBrandJgByCPIDANDSJTJQY(data) {
  return request({
    url: "/api/restful/findDataBrandJgByCPIDANDSJTJQY",
    method: "get",
    params: data
  });
}

//查看企业生产图表接口
export function findDataBrandScByIDTJQY(data) {
  return request({
    url: "/api/restful/findDataBrandScByIDTJQY",
    method: "get",
    params: data
  });
}
//查看企业加工图表接口
export function findDataBrandJgByIDTJQY(data) {
  return request({
    url: "/api/restful/findDataBrandJgByIDTJQY",
    method: "get",
    params: data
  });
}
//市场环境大屏综合指标
export function findDataBySCZHZB() {
  return request({
    // url: "/api/restful/findDataBySCZHZB",
    url: "api/dp/visual/queryList?code=yx_headdata",
    method: "get"
  });
}
//市场环境大屏左边菜单
export function findDataBySCMENU() {
  return request({
    url: "/api/restful/findDataBySCMENU",
    method: "get"
  });
}

//查询分店列表
export function findShopBranchListPage() {
  return request({
    url: "/api/restful/findShopBranchListPage",
    method: "get"
  });
}
//查询客户类型字典值
export function getDictDetailAll(data) {
  return request({
    url: "/api/restful/getDictDetailAll",
    method: "get",
    params: data
  });
}
//查询所有门店
export function findShopBranchAll(data) {
  return request({
    url: "/api/restful/findShopBranchAll",
    method: "get",
    params: data
  });
}
//查询所有客户
export function findCustomerAll(data) {
  return request({
    url: "/api/restful/findCustomerAll",
    method: "get",
    params: data
  });
}
//查询所有客户流向
export function findCustomerAllLX(data) {
  return request({
    url: "/api/restful/findCustomerAllLX",
    method: "get",
    params: data
  });
}
//梅江蔬菜客户和门店图表数据
export function findShopOrderTypeQtyByClientId(data) {
  return request({
    url: "/api/restful/findShopOrderTypeQtyByClientId",
    method: "get",
    params: data
  });
}
//梅江蔬菜客户和门店图表数据
export function findShopOrderTypeAmountByClientId(data) {
  return request({
    url: "/api/restful/findShopOrderTypeAmountByClientId",
    method: "get",
    params: data
  });
}
//梅江蔬菜门店销售数据
export function findShopBranchAllSort(data) {
  return request({
    url: "/api/restful/findShopBranchAllSort",
    method: "get",
    params: data
  });
}

//市场价格排行
export function getDataMarketPriceRank() {
  return request({
    url: "/api/restful/zsk/getDataMarketPriceRank",
    method: "get"
  });
}

//品种价格排行
export function getDataKindPriceRank() {
  return request({
    url: "/api/restful/zsk/getDataKindPriceRank",
    method: "get"
  });
}

//品牌建设指标数量
export function getDataBrandHeaddata() {
  return request({
    url: "/api/restful/getDataBrandHeaddata",
    method: "get"
  });
}

//品牌建设指标下详细信息
export function getDataBrandDataByCode(data) {
  return request({
    url: "/api/restful/getDataBrandDataByCode",
    method: "get",
    params: data
  });
}

// 价格变化趋势
export function getDataPriceDetailByYear(data) {
  return request({
    url: "/api/restful/getDataPriceDetailByYear",
    method: "get",
    params: data
  });
}
